(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('cart-drawer');

    if (!this.drawer) {
      console.warn('Cart drawer element not found');
      return;
    }

    this.content = document.getElementById('cart-drawer-content');
    this.countEl = document.getElementById('cart-drawer-count');
    this.subtotalEl = document.getElementById('cart-drawer-subtotal');

    // Translations (from data attribute)
    try {
      this.translations = JSON.parse(this.drawer.dataset.translations || '{}');
    } catch (e) {
      this.translations = {};
    }

    this.bindEvents();
    console.log('Cart drawer initialized');
  }

  bindEvents() {
    // Close drawer
    this.drawer.querySelectorAll('[data-cart-drawer-close]').forEach(el => {
      el.addEventListener('click', () => this.close());
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });

    // Quantity change
    this.drawer.addEventListener('click', async (e) => {
      const qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        e.preventDefault();
        await this.handleQuantityChange(qtyBtn);
      }

      const removeBtn = e.target.closest('[data-remove-item]');
      if (removeBtn) {
        e.preventDefault();
        await this.handleRemoveItem(removeBtn);
      }
    });
  }

  isOpen() {
    return this.drawer.getAttribute('aria-hidden') === 'false';
  }

  open() {
    this.drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }

  close() {
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  toggle() {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  async handleQuantityChange(btn) {
    const lineKey = btn.dataset.lineKey;
    const change = parseInt(btn.dataset.qtyChange, 10);
    const item = btn.closest('[data-cart-item]');
    const qtyEl = item.querySelector('[data-qty-value]');
    const currentQty = parseInt(qtyEl.textContent, 10);
    const newQty = Math.max(0, currentQty + change);

    item.classList.add('is-loading');

    try {
      const result = await this.updateCartItem(lineKey, newQty);

      // Check if quantity was adjusted due to stock limits
      if (result.items) {
        const updatedItem = result.items.find(i => i.key === lineKey);
        if (updatedItem && updatedItem.quantity < newQty) {
          this.showDrawerError(`Maximaal ${updatedItem.quantity} beschikbaar`);
        }
      }

      await this.refreshCart();
    } catch (error) {
      console.error('Error updating quantity:', error);
      this.showDrawerError(error.message || 'Kon aantal niet wijzigen');
    }

    item.classList.remove('is-loading');
  }

  async handleRemoveItem(btn) {
    const lineKey = btn.dataset.lineKey;
    const item = btn.closest('[data-cart-item]');

    item.classList.add('is-removing');

    try {
      await this.updateCartItem(lineKey, 0);
      await this.refreshCart();
    } catch (error) {
      console.error('Error removing item:', error);
      item.classList.remove('is-removing');
    }
  }

  async updateCartItem(lineKey, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      const message = errorData && (errorData.description || errorData.message);
      throw new Error(message || 'Kon aantal niet wijzigen');
    }

    return response.json();
  }

  async addToCart(variantId, quantity = 1) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    });

    if (!response.ok) {
      throw new Error('Failed to add to cart');
    }

    const data = await response.json();

    // Report the add to the OpenAI (ChatGPT ads) pixel
    if (typeof oaiq === 'function') oaiq('measure', 'items_added', { type: 'contents' });

    await this.refreshCart();
    this.open();

    return data;
  }

  async refreshCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      // Update count
      if (this.countEl) {
        this.countEl.textContent = `(${cart.item_count})`;
      }

      // Update subtotal
      if (this.subtotalEl) {
        this.subtotalEl.textContent = this.formatMoney(cart.total_price);
      }

      // Refresh shipping estimates
      if (window.shippingEstimate) {
        window.shippingEstimate.refresh();
      }
      if (window.drawerShippingRefresh) {
        window.drawerShippingRefresh();
      }

      // Rebuild items list
      await this.rebuildItemsList(cart);

      // Update header cart count
      this.updateHeaderCartCount(cart.item_count);

      // Update shipping progress bar
      this.updateShippingProgress(cart.total_price);

      // Show/hide footer based on cart contents
      this.updateFooterVisibility(cart.item_count > 0);

    } catch (error) {
      console.error('Error refreshing cart:', error);
    }
  }

  async rebuildItemsList(cart) {
    if (!this.content) return;

    if (cart.items.length === 0) {
      this.content.innerHTML = this.getEmptyCartHTML();
      return;
    }

    // Preserve condition data from existing items before rebuilding
    const conditionData = {};
    this.content.querySelectorAll('[data-cart-item]').forEach(item => {
      const key = item.dataset.lineId;
      if (key) {
        conditionData[key] = {
          condition: item.dataset.condition || 'nieuw',
          conditionLabel: item.dataset.conditionLabel || 'Nieuw'
        };
      }
    });

    const itemsHTML = cart.items.map(item => this.getItemHTML(item, conditionData[item.key])).join('');
    this.content.innerHTML = `<div class="cart-drawer__items" id="cart-drawer-items">${itemsHTML}</div>`;
  }

  getItemHTML(item, conditionInfo = null) {
    const imageUrl = item.image ? item.image.replace(/(\.[^.]+)$/, '_120x120$1') : '';
    const variantTitle = item.variant_title || '';
    const showVariant = variantTitle && variantTitle !== 'Default Title';
    const props = item.properties || {};
    const condition = conditionInfo?.condition || props._condition || 'nieuw';
    const conditionLabel = conditionInfo?.conditionLabel || props._condition_label || 'Nieuw';

    return `
      <div class="cart-drawer__item" data-cart-item data-line-id="${item.key}" data-condition="${condition}" data-condition-label="${this.escapeHtml(conditionLabel)}">
        <div class="cart-drawer__item-image-col">
          <a href="${item.url}" class="cart-drawer__item-image">
            ${imageUrl ? `<img src="${imageUrl}" alt="${item.title}" loading="lazy">` : '<div class="cart-drawer__placeholder"></div>'}
          </a>
          <span class="cart-drawer__item-condition cart-drawer__item-condition--${condition}">${this.escapeHtml(conditionLabel)}</span>
        </div>
        <div class="cart-drawer__item-details">
          <a href="${item.url}" class="cart-drawer__item-title">${item.product_title}</a>
          ${showVariant ? `<p class="cart-drawer__item-variant">${variantTitle}</p>` : ''}
          <div class="cart-drawer__item-price">
            ${item.original_price !== item.final_price
              ? `<span class="cart-drawer__item-sale-price">${this.formatMoney(item.final_price)}</span>
                 <span class="cart-drawer__compare-label">${this.translations.compareLabel || 'Normally'}</span>
                 <span class="cart-drawer__item-original-price">${this.formatMoney(item.original_price)}</span>`
              : `<span>${this.formatMoney(item.final_price)}</span>`}
          </div>
          <div class="cart-drawer__item-quantity">
            <button type="button" class="cart-drawer__qty-btn no-touch-target" data-qty-change="-1" data-line-key="${item.key}">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            </button>
            <span class="cart-drawer__qty-value" data-qty-value>${item.quantity}</span>
            <button type="button" class="cart-drawer__qty-btn no-touch-target" data-qty-change="1" data-line-key="${item.key}">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            </button>
          </div>
        </div>
        <button type="button" class="cart-drawer__item-remove" data-remove-item data-line-key="${item.key}">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          </svg>
        </button>
      </div>
    `;
  }

  getEmptyCartHTML() {
    return `
      <div class="cart-drawer__empty" id="cart-drawer-empty">
        <svg class="cart-drawer__empty-icon" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="9" cy="21" r="1"></circle>
          <circle cx="20" cy="21" r="1"></circle>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
        </svg>
        <p class="cart-drawer__empty-title">${this.translations.emptyTitle}</p>
        <p class="cart-drawer__empty-text">${this.translations.emptyText}</p>
        <a href="/collections/all" class="cart-drawer__empty-btn" data-cart-drawer-close>
          ${this.translations.startShopping}
        </a>
      </div>
    `;
  }

  updateShippingProgress(totalPrice) {
    const container = document.getElementById('cart-drawer-shipping-progress');
    if (!container) return;

    const threshold = parseInt(container.dataset.threshold, 10) || 5000;
    const remaining = threshold - totalPrice;

    if (totalPrice >= threshold) {
      container.innerHTML = `
        <div class="cart-drawer__progress cart-drawer__progress--complete">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
            <polyline points="22 4 12 14.01 9 11.01"/>
          </svg>
          <span>${this.translations.freeShippingAchieved || 'You have free shipping!'}</span>
        </div>
      `;
    } else {
      const pct = Math.min(100, Math.round((totalPrice / threshold) * 100));
      const amountText = this.formatMoney(remaining);
      const template = this.translations.freeShippingRemaining || 'Add __AMOUNT__ for free shipping';
      const text = template.replace('__AMOUNT__', amountText);
      container.innerHTML = `
        <div class="cart-drawer__progress">
          <div class="cart-drawer__progress-header">
            <p class="cart-drawer__progress-text">${text}</p>
            <span class="cart-drawer__shipping-cost" id="cart-drawer-shipping-cost"></span>
          </div>
          <div class="cart-drawer__progress-bar">
            <div class="cart-drawer__progress-fill" style="width: ${pct}%"></div>
          </div>
        </div>
      `;
    }

    // Re-fetch shipping cost after progress update
    if (typeof window.drawerShippingRefresh === 'function') {
      window.drawerShippingRefresh();
    }
  }

  updateFooterVisibility(hasItems) {
    const footer = this.drawer.querySelector('.cart-drawer__footer');
    if (footer) {
      footer.classList.toggle('cart-drawer__footer--hidden', !hasItems);
    }
  }

  formatMoney(cents) {
    // Format money in EUR - show "€X,-" when cents are 00
    const remainder = cents % 100;
    if (remainder === 0) {
      return '€' + Math.floor(cents / 100) + ',-';
    }
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }

  updateHeaderCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.classList.toggle('header__cart-badge--hidden', count === 0);
    });
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  showDrawerError(message) {
    // Remove existing error
    const existingError = this.drawer.querySelector('.cart-drawer__error');
    if (existingError) existingError.remove();

    // Create error element
    const errorEl = document.createElement('div');
    errorEl.className = 'cart-drawer__error';
    errorEl.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
      <span>${this.escapeHtml(message)}</span>
    `;

    // Insert after header
    const header = this.drawer.querySelector('.cart-drawer__header');
    if (header) {
      header.insertAdjacentElement('afterend', errorEl);
    }

    // Auto-hide after 4 seconds
    setTimeout(() => {
      if (errorEl.parentNode) {
        errorEl.classList.add('cart-drawer__error--hiding');
        setTimeout(() => errorEl.remove(), 300);
      }
    }, 4000);
  }

  // Load product suggestions for upsell
  async loadSuggestions() {
    const suggestionsEl = document.getElementById('cart-drawer-suggestions');
    if (!suggestionsEl) return;

    try {
      // Get product handle from data attribute or from cart
      let productHandle = suggestionsEl.dataset.productHandle;

      if (!productHandle) {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        if (cart.items.length === 0) {
          suggestionsEl.innerHTML = '';
          return;
        }
        productHandle = cart.items[0].handle;
      }

      const response = await fetch(`/products/${productHandle}/recommendations.json?limit=6&intent=related`);
      if (!response.ok) {
        suggestionsEl.innerHTML = '';
        return;
      }

      const data = await response.json();
      if (data.products && data.products.length > 0) {
        this.renderSuggestionsFromJson(suggestionsEl, data.products);
      } else {
        suggestionsEl.innerHTML = '';
      }
    } catch (error) {
      console.error('Error loading suggestions:', error);
      suggestionsEl.innerHTML = '';
    }
  }

  renderSuggestionsFromJson(container, products) {
    const cardsHTML = products.map(product => {
      const imageUrl = product.featured_image ? product.featured_image.replace(/(\.[^.]+)$/, '_100x100$1') : '';
      const variantId = product.variants[0]?.id;
      return `
        <div class="cart-drawer__suggestion-card">
          <a href="${product.url}" class="cart-drawer__suggestion-image">
            ${imageUrl ? `<img src="${imageUrl}" alt="${this.escapeHtml(product.title)}" loading="lazy">` : ''}
          </a>
          <p class="cart-drawer__suggestion-name">${this.escapeHtml(product.title)}</p>
          <div class="cart-drawer__suggestion-bottom">
            <span class="cart-drawer__suggestion-price">${this.formatMoney(product.price)}</span>
            <button type="button" class="cart-drawer__suggestion-add" data-add-suggestion="${variantId}" aria-label="Toevoegen">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
            </button>
          </div>
        </div>
      `;
    }).join('');

    container.innerHTML = `
      <p class="cart-drawer__suggestions-title">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
        ${this.translations.suggestionsTitle || 'Misschien ook interessant'}
      </p>
      <div class="cart-drawer__suggestions-scroll">${cardsHTML}</div>
    `;

    this.bindSuggestionAddButtons();
  }

  bindSuggestionAddButtons() {
    this.drawer.querySelectorAll('[data-add-suggestion]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const variantId = btn.dataset.addSuggestion;
        if (!variantId) return;

        btn.classList.add('is-loading');

        try {
          await this.addToCart(variantId, 1);
        } catch (error) {
          console.error('Error adding suggestion:', error);
        }

        btn.classList.remove('is-loading');
      });
    });
  }
}

// Initialize cart drawer
window.cartDrawer = new CartDrawer();

// Load suggestions when drawer opens
document.addEventListener('DOMContentLoaded', () => {
  if (window.cartDrawer) {
    // Load suggestions initially if cart has items
    const suggestionsEl = document.getElementById('cart-drawer-suggestions');
    if (suggestionsEl && suggestionsEl.dataset.url) {
      window.cartDrawer.loadSuggestions();
    }
  }
});

// Drawer Shipping Cost (auto-fetch, inline display)
(function() {
  var isNl = document.documentElement.lang === 'nl';
  var url = '/cart/shipping_rates.json?shipping_address[zip]=&shipping_address[country]=NL';

  async function fetchShippingCost() {
    var el = document.getElementById('cart-drawer-shipping-cost');
    if (!el) return;

    try {
      var response = await fetch(url);
      if (!response.ok) return;

      var data = await response.json();
      var rates = data.shipping_rates || [];
      if (rates.length === 0) return;

      var cheapest = rates.reduce(function(min, r) {
        return parseFloat(r.price) < parseFloat(min.price) ? r : min;
      }, rates[0]);
      var price = parseFloat(cheapest.price);

      if (price === 0) {
        el.textContent = '';
      } else {
        var formatted = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(price);
        el.textContent = (isNl ? 'Verzending: ' : 'Shipping: ') + formatted;
      }
    } catch (e) {
      // Silently fail - the progress bar still works without the cost
    }
  }

  fetchShippingCost();

  // Expose for cart drawer refresh
  window.drawerShippingRefresh = fetchShippingCost;
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-subcategory-nav"] && !Shopify.designMode) return;
  try {
    (function() {
  var scroll = document.getElementById('subcategory-scroll');
  var fade = document.getElementById('subcategory-fade');
  if (!scroll) return;

  function updateFade() {
    if (!fade) return;
    var hasOverflow = scroll.scrollWidth > scroll.clientWidth;
    var atEnd = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 2;
    if (hasOverflow && !atEnd) {
      fade.classList.add('subcategory-nav__fade--visible');
    } else {
      fade.classList.remove('subcategory-nav__fade--visible');
    }
  }

  scroll.addEventListener('scroll', updateFade, { passive: true });
  updateFade();

  /* Auto-scroll to active pill on mobile */
  if (window.innerWidth >= 769) return;
  var active = scroll.querySelector('.subcategory-nav__pill--active');
  if (!active) return;
  var li = active.closest('.subcategory-nav__item');
  if (!li) return;
  scroll.scrollLeft = li.offsetLeft - scroll.offsetLeft - 16;
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    (function() {
    var DEBOUNCE_MS = 300;
    var MIN_QUERY_LENGTH = 2;
    var SECTION_ID = 'predictive-search';
    var RESULTS_LIMIT = 4;

    var dropdowns = document.querySelectorAll('[data-predictive-search-for]');

    dropdowns.forEach(function(dropdown) {
      var inputId = dropdown.getAttribute('data-predictive-search-for');
      var input = document.getElementById(inputId);
      if (!input) return;

      var resultsContainer = dropdown.querySelector('[data-predictive-search-results]');
      var debounceTimer = null;
      var abortController = null;
      var isOpen = false;

      function open() {
        if (isOpen) return;
        isOpen = true;
        dropdown.classList.add('is-open');
        input.setAttribute('aria-expanded', 'true');
      }

      function close() {
        if (!isOpen) return;
        isOpen = false;
        dropdown.classList.remove('is-open');
        input.setAttribute('aria-expanded', 'false');
      }

      function showLoading() {
        resultsContainer.innerHTML =
          '<div class="predictive-search__loading">' +
            '<div class="predictive-search__spinner"></div>' +
          '</div>';
        open();
      }

      function fetchResults(query) {
        if (abortController) {
          abortController.abort();
        }
        abortController = new AbortController();

        var url = window.Shopify.routes.root + 'search/suggest?q=' +
          encodeURIComponent(query) +
          '&resources[type]=query,product,collection' +
          '&resources[limit]=' + RESULTS_LIMIT +
          '&resources[options][unavailable_products]=hide' +
          '&section_id=' + SECTION_ID;

        showLoading();

        fetch(url, { signal: abortController.signal })
          .then(function(response) {
            if (response.status === 429) {
              var retryAfter = parseInt(response.headers.get('Retry-After'), 10) || 1;
              setTimeout(function() { fetchResults(query); }, retryAfter * 1000);
              return null;
            }
            if (!response.ok) {
              throw new Error('Search request failed: ' + response.status);
            }
            return response.text();
          })
          .then(function(text) {
            if (text === null) return;

            var parser = new DOMParser();
            var doc = parser.parseFromString(text, 'text/html');
            var section = doc.getElementById('shopify-section-' + SECTION_ID);

            if (section && section.innerHTML.trim()) {
              resultsContainer.innerHTML = section.innerHTML;
              open();
            } else {
              close();
              resultsContainer.innerHTML = '';
            }
          })
          .catch(function(error) {
            if (error.name === 'AbortError') return;
            close();
            resultsContainer.innerHTML = '';
          });
      }

      function onInput() {
        var query = input.value.trim();

        if (debounceTimer) {
          clearTimeout(debounceTimer);
        }

        if (query.length < MIN_QUERY_LENGTH) {
          if (abortController) abortController.abort();
          close();
          resultsContainer.innerHTML = '';
          return;
        }

        debounceTimer = setTimeout(function() {
          fetchResults(query);
        }, DEBOUNCE_MS);
      }

      input.addEventListener('input', onInput);

      input.addEventListener('focus', function() {
        if (input.value.trim().length >= MIN_QUERY_LENGTH && resultsContainer.innerHTML.trim()) {
          open();
        }
      });

      document.addEventListener('click', function(e) {
        if (!dropdown.contains(e.target) && e.target !== input && !input.contains(e.target)) {
          close();
        }
      });

      input.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          close();
          input.blur();
        }
      });

      // Een input[type=search] heeft de rol searchbox, en die ondersteunt geen
      // aria-expanded of aria-haspopup. Met role=combobox zijn ze wel geldig.
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-haspopup', 'listbox');
      if (resultsContainer && resultsContainer.id) {
        input.setAttribute('aria-controls', resultsContainer.id);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // AJAX Add to Cart for Product Cards
document.addEventListener('submit', async function(e) {
  const form = e.target.closest('.product-card__form--ajax');
  if (!form) return;

  e.preventDefault();

  const btn = form.querySelector('[data-add-to-cart-btn]');
  if (!btn || btn.classList.contains('is-adding')) return;

  // Add ripple effect
  btn.classList.add('is-ripple');
  setTimeout(() => btn.classList.remove('is-ripple'), 400);

  // Start loading state
  btn.classList.add('is-adding');

  const formData = new FormData(form);
  const variantId = formData.get('id');
  const quantity = parseInt(formData.get('quantity'), 10) || 1;

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    });

    if (!response.ok) {
      throw new Error('Failed to add to cart');
    }

    await response.json();

    // Report the add to the OpenAI (ChatGPT ads) pixel
    if (typeof oaiq === 'function') oaiq('measure', 'items_added', { type: 'contents' });

    // Show success state
    btn.classList.remove('is-adding');
    btn.classList.add('is-added');

    // Open cart drawer if available
    if (window.cartDrawer) {
      await window.cartDrawer.refreshCart();
      window.cartDrawer.open();
    }

    // Reset button after delay
    setTimeout(() => {
      btn.classList.remove('is-added');
    }, 1500);

  } catch (error) {
    console.error('Add to cart error:', error);
    btn.classList.remove('is-adding');
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-estimate"] && !Shopify.designMode) return;
  try {
    class ShippingEstimate {
    constructor() {
      this.elements = document.querySelectorAll('[data-shipping-estimate]');
      if (this.elements.length === 0) return;

      this.refresh();
    }

    async refresh() {
      for (const el of this.elements) {
        const country = el.dataset.country;
        if (!country) continue;
        await this.fetchAndUpdate(el, country);
      }
    }

    async fetchAndUpdate(el, country) {
      const priceEl = el.querySelector('[data-shipping-price]');
      if (!priceEl) return;

      try {
        const url = `/cart/shipping_rates.json?shipping_address[zip]=&shipping_address[country]=${encodeURIComponent(country)}`;
        const response = await fetch(url);

        if (!response.ok) {
          priceEl.textContent = el.dataset.checkoutFallback || priceEl.textContent;
          return;
        }

        const data = await response.json();
        const rates = data.shipping_rates || [];

        if (rates.length === 0) {
          priceEl.textContent = el.dataset.checkoutFallback || priceEl.textContent;
          return;
        }

        const cheapest = rates.reduce((min, r) =>
          parseFloat(r.price) < parseFloat(min.price) ? r : min
        , rates[0]);

        const price = parseFloat(cheapest.price);

        if (price === 0) {
          priceEl.textContent = el.dataset.freeLabel || 'Gratis';
          priceEl.classList.add('shipping-estimate__price--free');
        } else {
          priceEl.textContent = this.formatPrice(price);
          priceEl.classList.remove('shipping-estimate__price--free');
        }
      } catch (e) {
        /* Keep current text on network error */
      }
    }

    formatPrice(amount) {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR'
      }).format(amount);
    }
  }

  window.shippingEstimate = new ShippingEstimate();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-selector-modal"] && !Shopify.designMode) return;
  try {
    (function() {
    function initVariantModal() {
    var modal = document.getElementById('variant-modal');
    if (!modal) return;

    var loadingEl = modal.querySelector('[data-variant-modal-loading]');
    var contentEl = modal.querySelector('[data-variant-modal-content]');
    var imageEl = modal.querySelector('[data-variant-modal-image]');
    var titleEl = modal.querySelector('[data-variant-modal-product-title]');
    var priceEl = modal.querySelector('[data-variant-modal-price]');
    var optionsEl = modal.querySelector('[data-variant-modal-options]');
    var addBtn = modal.querySelector('[data-variant-modal-add]');

    var selectedVariantId = null;
    var currentProduct = null;
    var currentConditionData = null;

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      return '€ ' + amount;
    }

    function open() {
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      selectedVariantId = null;
      currentProduct = null;
    }

    function showLoading() {
      loadingEl.style.display = '';
      contentEl.style.display = 'none';
    }

    function showContent() {
      loadingEl.style.display = 'none';
      contentEl.style.display = '';
    }

    function populateModal(product) {
      currentProduct = product;

      // Image
      if (product.featured_image) {
        imageEl.innerHTML = '<img src="' + product.featured_image.replace(/\.([a-z]+)$/i, '_200x200.$1') + '" alt="' + escapeAttr(product.title) + '" loading="lazy">';
      } else {
        imageEl.innerHTML = '';
      }

      // Title
      titleEl.textContent = product.title;

      // Price - show range of available variants only
      var availableVariants = product.variants.filter(function(v) { return v.available; });
      var prices = availableVariants.map(function(v) { return v.price; });
      var minPrice = Math.min.apply(null, prices);
      var maxPrice = Math.max.apply(null, prices);
      if (minPrice === maxPrice) {
        priceEl.textContent = formatMoney(minPrice);
      } else {
        priceEl.textContent = formatMoney(minPrice) + ' – ' + formatMoney(maxPrice);
      }

      // Options - render each variant as a button
      optionsEl.innerHTML = '';

      // Group by first option if there are option names
      if (product.options && product.options.length === 1) {
        var optionName = product.options[0];
        if (typeof optionName === 'object' && optionName.name) {
          optionName = optionName.name;
        }
        var groupLabel = document.createElement('p');
        groupLabel.className = 'variant-modal__option-group-label';
        groupLabel.textContent = optionName;
        optionsEl.appendChild(groupLabel);
      }

      var buttonsContainer = document.createElement('div');
      buttonsContainer.className = 'variant-modal__option-buttons';

      product.variants.forEach(function(variant) {
        // Skip sold-out variants
        if (!variant.available) return;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'variant-modal__option-btn';

        var label = document.createElement('span');
        label.className = 'variant-modal__option-label';
        label.textContent = variant.title;
        btn.appendChild(label);

        var price = document.createElement('span');
        price.className = 'variant-modal__option-price';
        price.textContent = formatMoney(variant.price);
        btn.appendChild(price);

        btn.addEventListener('click', function() {
          selectVariant(variant, btn);
        });

        buttonsContainer.appendChild(btn);
      });

      optionsEl.appendChild(buttonsContainer);

      // Auto-select if only one available variant
      var renderedBtns = buttonsContainer.querySelectorAll('.variant-modal__option-btn');
      if (renderedBtns.length === 1) {
        renderedBtns[0].click();
      }

      // Reset add button
      addBtn.disabled = true;
      selectedVariantId = null;

      showContent();
    }

    function selectVariant(variant, btn) {
      // Deselect all
      optionsEl.querySelectorAll('.variant-modal__option-btn').forEach(function(b) {
        b.classList.remove('is-selected');
      });

      // Select this one
      btn.classList.add('is-selected');
      selectedVariantId = variant.id;

      // Update price display
      priceEl.textContent = formatMoney(variant.price);

      // Update image if variant has one
      if (variant.featured_image) {
        imageEl.innerHTML = '<img src="' + variant.featured_image.src.replace(/\.([a-z]+)$/i, '_200x200.$1') + '" alt="' + escapeAttr(currentProduct.title) + '" loading="lazy">';
      }

      // Enable add button
      addBtn.disabled = false;
    }

    async function addToCart() {
      if (!selectedVariantId) return;

      addBtn.classList.add('is-adding');

      try {
        var modalBody = { id: selectedVariantId, quantity: 1 };
        if (currentConditionData && currentConditionData.condition) {
          modalBody.properties = {
            _condition: currentConditionData.condition,
            _condition_label: currentConditionData.conditionLabel || ''
          };
        }

        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(modalBody)
        });

        var data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Could not add to cart');
        }

        // Report the add to the OpenAI (ChatGPT ads) pixel
        if (typeof oaiq === 'function') oaiq('measure', 'items_added', { type: 'contents' });

        addBtn.classList.remove('is-adding');
        close();

        // Open cart drawer
        if (window.cartDrawer && typeof window.cartDrawer.refreshCart === 'function') {
          await window.cartDrawer.refreshCart();
          window.cartDrawer.open();
        }
      } catch (error) {
        addBtn.classList.remove('is-adding');
        alert(error.message);
      }
    }

    function escapeAttr(str) {
      return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    // Event: open modal from product card
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-variant-modal]');
      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();

      var handle = trigger.getAttribute('data-variant-modal');
      if (!handle) return;

      // Store condition data from the trigger button
      currentConditionData = {
        condition: trigger.getAttribute('data-condition') || null,
        conditionLabel: trigger.getAttribute('data-condition-label') || null
      };

      showLoading();
      open();

      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          populateModal(product);
        })
        .catch(function() {
          close();
        });
    });

    // Event: close modal
    modal.querySelectorAll('[data-variant-modal-close]').forEach(function(el) {
      el.addEventListener('click', close);
    });

    // Event: Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        close();
      }
    });

    // Event: add to cart
    addBtn.addEventListener('click', addToCart);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initVariantModal);
    } else {
      initVariantModal();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["webwinkelkeur-rating"] && !Shopify.designMode) return;
  try {
    (function() {
  const API_URL = 'https://dashboard.webwinkelkeur.nl/api/1.0/ratings_summary.json?id=1219387&public_code=7c925fab21b2e8ad6cde6bfb73bebdd8a0108273bb14810b43c4ce53b0c393d8&language=nl';

  // Cache key for localStorage
  const CACHE_KEY = 'wwk_rating_cache';
  const CACHE_DURATION = 3600000; // 1 hour in milliseconds

  function getCachedData() {
    try {
      const cached = localStorage.getItem(CACHE_KEY);
      if (cached) {
        const { data, timestamp } = JSON.parse(cached);
        if (Date.now() - timestamp < CACHE_DURATION) {
          return data;
        }
      }
    } catch (e) {
      // Ignore cache errors
    }
    return null;
  }

  function setCachedData(data) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({
        data: data,
        timestamp: Date.now()
      }));
    } catch (e) {
      // Ignore cache errors
    }
  }

  function generateStarsHTML(ratingOutOf10) {
    // Convert 10-point scale to 5-star scale
    const starsRating = (ratingOutOf10 / 10) * 5;
    const fullStars = Math.floor(starsRating);
    const partialFill = starsRating - fullStars;
    const emptyStars = 5 - fullStars - (partialFill > 0 ? 1 : 0);

    // Create unique ID for this instance's gradient
    const gradientId = 'wwk-partial-' + Math.random().toString(36).substr(2, 9);

    let html = '';

    // SVG definitions for partial fill gradient
    if (partialFill > 0) {
      html += '<svg width="0" height="0" style="position:absolute"><defs>';
      html += '<linearGradient id="' + gradientId + '">';
      html += '<stop offset="' + (partialFill * 100) + '%" stop-color="#f5a623"/>';
      html += '<stop offset="' + (partialFill * 100) + '%" stop-color="#e0e0e0"/>';
      html += '</linearGradient></defs></svg>';
    }

    // Full stars
    for (let i = 0; i < fullStars; i++) {
      html += '<svg class="wwk-rating__star wwk-rating__star--filled" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }

    // Partial star
    if (partialFill > 0) {
      html += '<svg class="wwk-rating__star" viewBox="0 0 24 24"><path fill="url(#' + gradientId + ')" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }

    // Empty stars
    for (let i = 0; i < emptyStars; i++) {
      html += '<svg class="wwk-rating__star wwk-rating__star--empty" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }

    return html;
  }

  function updateRatingDisplays(data) {
    const ratingAvg = data.rating_average;
    const reviewCount = data.amount;

    // Round to 1 decimal place
    const displayScore = Math.round(ratingAvg * 10) / 10;
    // Format with comma for Dutch locale
    const formattedScore = displayScore.toFixed(1).replace('.', ',');

    // Update all rating components on the page
    document.querySelectorAll('[data-wwk-rating]').forEach(function(container) {
      const starsContainer = container.querySelector('[data-wwk-stars]');
      const scoreElement = container.querySelector('[data-wwk-score]');
      const countElement = container.querySelector('[data-wwk-count]');

      if (starsContainer) {
        starsContainer.innerHTML = generateStarsHTML(ratingAvg);
      }

      if (scoreElement) {
        scoreElement.textContent = formattedScore + ' | ' + reviewCount + ' Reviews';
      }

      if (countElement) {
        countElement.textContent = '(' + reviewCount + ')';
      }
    });
  }

  function fetchRating() {
    // Check cache first
    const cachedData = getCachedData();
    if (cachedData) {
      updateRatingDisplays(cachedData);
      return;
    }

    // Fetch from API
    fetch(API_URL)
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(function(result) {
        if (result.status === 'success' && result.data) {
          setCachedData(result.data);
          updateRatingDisplays(result.data);
        }
      })
      .catch(function(error) {
        console.warn('Failed to fetch WebwinkelKeur rating:', error);
        // Show fallback rating if available
        updateRatingDisplays({
          rating_average: 8.8,
          amount: 267
        });
      });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchRating);
  } else {
    fetchRating();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
